import { DEFAULT_VOICE_BLOB_STYLE } from "@brandclub/bc-widgets";
import { useVoiceThemeContext } from "./VoiceThemeProvider.js";
function useVoicePersona() {
  const { persona, visual } = useVoiceThemeContext();
  return {
    assistantName: persona.assistantName || "Benny",
    voiceId: persona.voiceId,
    blobStyle: (visual == null ? void 0 : visual.blobStyle) ?? DEFAULT_VOICE_BLOB_STYLE
  };
}
export {
  useVoicePersona
};
//# sourceMappingURL=useVoicePersona.js.map
